"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var Remove_1 = __importDefault(require("@material-ui/icons/Remove"));

var Component_1 = __importDefault(require("./Component"));

var createPlugin = function createPlugin(settings) {
  if (settings === void 0) {
    settings = {
      Controls: function Controls() {
        return React.createElement(React.Fragment, null, "Controls for this plugin were not provided");
      },
      Renderer: function Renderer() {
        return React.createElement(React.Fragment, null, "Renderer for this plugin was not provided");
      }
    };
  }

  var WrappedComponent = function WrappedComponent(props) {
    return React.createElement(Component_1.default, __assign({}, props, settings));
  };

  return {
    Component: WrappedComponent,
    StaticComponent: settings.Renderer,
    name: 'ory/editor/core/content/divider',
    version: '0.0.1',
    IconComponent: React.createElement(Remove_1.default, null),
    text: 'Divider',
    description: 'A horizontal divider.'
  };
};

exports.default = createPlugin;